/** Angular Imports */
import { Injectable, inject } from '@angular/core';

/** rxjs Imports */
import { Observable } from 'rxjs';

/** Custom Services */
import { SystemService } from '../system.service';

/**
 * Report Template data resolver.
 */
@Injectable()
export class ReportTemplateResolver {
  private systemService = inject(SystemService);

  /**
   * Returns the Report Template data.
   * @returns {Observable<any>}
   */
  resolve(): Observable<any> {
    return this.systemService.getReportTemplate();
  }
}
